import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para autenticación y administración de Colaboradores
 * @module ServicioColaboradores
 */
const colaboradores = URL_BACK + '/colaboradores/getColaboradores.php'
const misColaboradores = URL_BACK + '/colaboradores/getMisColaboradores.php'
const setColaborador = URL_BACK + '/colaboradores/setColaborador.php'

/**
 * Funciones para autenticación y administración de usuarios.
 */

export default {
  /**
   * Colaboradores
   * @param {object} model - Modelo de inicio de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  colaboradores (model) {
    return new Promise((resolve, reject) => {
      api
        .post(colaboradores, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Colaboradores
   * @param {object} model - Modelo de inicio de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  misColaboradores (model) {
    return new Promise((resolve, reject) => {
      api
        .post(misColaboradores, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * Colaboradores
   * @param {object} model - Modelo de inicio de sesión.
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  setColaborador (model) {
    return new Promise((resolve, reject) => {
      api
        .post(setColaborador, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
    
}
